import React, { useState, useRef, useEffect } from "react";
import MEANS_OPTIONS from "../../components/utils/MeansOptions";

export default function MeansSelector({ value, onChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef();

  const toggleOption = (option) => {
    if (value.includes(option.value)) {
      onChange(value.filter((v) => v !== option.value));
    } else {
      onChange([...value, option.value]);
    }
  };

  const removeOption = (optionValue) => {
    onChange(value.filter((v) => v !== optionValue));
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative text-white" ref={ref}>
      <label className="block font-medium text-green-500 mb-2">Mezzi</label>

      <div
        className="w-full border border-secondary rounded bg-primary p-2 cursor-pointer flex flex-wrap gap-1 min-h-[44px]"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        {value.length === 0 ? (
          <span className="text-gray-400">Seleziona Mezzi</span>
        ) : (
          value.map((val) => {
            const option = MEANS_OPTIONS.find((o) => o.value === val);
            return (
              <span
                key={val}
                className="bg-secondary px-2 py-1 text-xs rounded-full flex items-center gap-2"
              >
                {option?.label || val}
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    removeOption(val);
                  }}
                  className="text-white hover:text-red-400 text-xs"
                >
                  ✕
                </button>
              </span>
            );
          })
        )}
      </div>

      {isOpen && (
        <div className="absolute z-10 mt-2 w-full bg-primary border border-secondary rounded shadow-lg max-h-[200px] overflow-y-auto">
          {MEANS_OPTIONS.map((option) => (
            <div
              key={option.value}
              className={`px-3 py-2 hover:bg-secondary cursor-pointer text-sm flex justify-between items-center ${value.includes(option.value) ? "bg-secondary" : ""
                }`}
              onClick={() => toggleOption(option)}
            >
              {option.label}
              {value.includes(option.value) && <span>✓</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
